import { __awaiter, __generator } from "tslib";
import { Text } from '@wix/design-system';
import classnames from 'classnames';
import React, { useCallback, useEffect, useState, } from 'react';
import { DATA_HOOKS } from '../../../dataHooks';
import { getTopOffsetForScrollToArticlePage } from '../../../utils/scroll';
export var ScrollSpy = function (_a) {
    var steps = _a.steps, consumerSource = _a.consumerSource, onClick = _a.onClick;
    var _b = useState(steps.length > 0 ? steps[0].id : ''), activeStepId = _b[0], setActiveStepId = _b[1];
    var onScroll = useCallback(function () {
        for (var i = 0; i < steps.length; i++) {
            var stepElement = document === null || document === void 0 ? void 0 : document.getElementById(steps[i].id);
            var scrollAndHeaderHeight = window.scrollY + getTopOffsetForScrollToArticlePage();
            if (scrollAndHeaderHeight >= (stepElement === null || stepElement === void 0 ? void 0 : stepElement.offsetTop) - 10) {
                if (i === steps.length - 1) {
                    setActiveStepId(steps[i].id);
                    return;
                }
                else {
                    var nextStepElement = document === null || document === void 0 ? void 0 : document.getElementById(steps[i + 1].id);
                    if (scrollAndHeaderHeight <=
                        (nextStepElement === null || nextStepElement === void 0 ? void 0 : nextStepElement.offsetTop) - 10) {
                        setActiveStepId(steps[i].id);
                        return;
                    }
                }
            }
        }
    }, [steps]);
    useEffect(function () {
        window === null || window === void 0 ? void 0 : window.addEventListener('scroll', onScroll);
        return function () {
            window === null || window === void 0 ? void 0 : window.removeEventListener('scroll', onScroll);
        };
    }, [onScroll]);
    return (React.createElement("ul", { className: "stepsWrapper ".concat(consumerSource) },
        React.createElement("div", { className: 'stepsLine' }),
        steps.map(function (step, index) { return (React.createElement("li", { key: step.id, className: classnames("level-".concat(step.level), "anchor-".concat(index)), onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, onClick(step.id, step.text, "".concat(index + 1))];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); } },
            React.createElement("div", null,
                React.createElement("span", { className: classnames('stepBullet', {
                        activeStepBullet: activeStepId === step.id,
                    }) },
                    React.createElement("span", { className: "activeIndicator" })),
                index === steps.length - 1 ? (React.createElement("span", { className: "lastStepClear" })) : null,
                React.createElement(Text, { size: 'small', dataHook: "".concat(DATA_HOOKS.SCROLL_SPY_ANCHOR, "-").concat(index + 1), className: classnames({
                        stepLinkTextActive: activeStepId === step.id,
                        stepLinkText: activeStepId !== step.id,
                    }) }, step.text)))); })));
};
//# sourceMappingURL=index.js.map